import { Api } from '@/interface/api';

/**
 * 获取专家列表
 * @param accountId
 */
const getExpertsList: Api = {
    url: '/api/project/proxy/api/experts',
    method: 'get',
};

export { getExpertsList };
